import { useEffect, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useGetCurrentBusinessId } from '@/modules/common/hooks/useGetCurrentBusinessId.ts';
import Forms from '@/modules/admin-dashboard/pages/Forms.tsx';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';

export const FormsByTag = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const businessId = useGetCurrentBusinessId();
  const initialBusinessIdRef = useRef(businessId);
  const isInvalidTagId = !id || !id.length || isNaN(+id) || +id < 1;

  useEffect(() => {
    if (!isInvalidTagId) return;
    navigate({ pathname: adminDashboardPaths.static.forms, search: params.toString() });
  }, [isInvalidTagId, navigate, params]);

  useEffect(() => {
    if (initialBusinessIdRef.current === businessId) return;
    navigate({ pathname: adminDashboardPaths.static.forms, search: params.toString() });
  }, [businessId, navigate, params]);

  if (isInvalidTagId) return null;

  return <Forms tagId={+id} />;
};
